import { ActionTypes } from "../constants/action-types";

const initialState = {
  mentors: [],
  totalmentors: 0,
};

export const FetchMentors = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_MENTORS_SUCCESS:
      return {
        ...state,
        mentors: action.payload,
        totalmentors: action.payload.length,
      };

    default:
      return state;
  }
};

export default FetchMentors;
